export function passwordPrompt(locale: string, error) {
  switch (locale) {
    case 'zh_hk':
      return passwordPromptZh(error);
    default:
      return passwordPromptEn(error);
  }
}

export function passwordPromptEn(error) {
  // var s = `Invalid password.`;
  var s = ``;
  if (error.length) {
    s += `Min. ${error.length} characters;`;
  }
  if (error.patternTypes) {
    s += ` contains any ${error.patternTypes} of `;
  } else {
    s += ' contains ';
  }
  let first = true;
  if (error.pattern.indexOf('a') >= 0) {
    if (!first) s += ', ';
    s += `small letter`;
    first = false;
  }
  if (error.pattern.indexOf('A') >= 0) {
    if (!first) s += ', ';
    s += `capital letter`;
    first = false;
  }
  if (error.pattern.indexOf('1') >= 0 || error.pattern.indexOf('0') >= 0) {
    if (!first) s += ', ';
    s += `number`;
    first = false;
  }
  if (error.pattern.indexOf('@') >= 0) {
    if (!first) s += ', ';
    s += `symbol`;
    first = false;
  }

  return s;
}

export function passwordPromptZh(error) {
  // var s = `密碼格式錯誤。`;
  var s = ``;
  if (error.length) {
    s += `最少${error.length}個字元; `;
  }

  if (error.patternTypes) {
    s += `包含 ${error.patternTypes}個 `;
  } else {
    s += `包含`;
  }
  let first = true;

  if (error.pattern.indexOf('a') >= 0) {
    if (!first) s += '、';
    s += `小寫英文字母`;
    first = false;
  }
  if (error.pattern.indexOf('A') >= 0) {
    if (!first) s += '、';
    s += `大寫英文字母`;
    first = false;
  }
  if (error.pattern.indexOf('1') >= 0 || error.pattern.indexOf('0') >= 0) {
    if (!first) s += '、';
    s += `數字`;
    first = false;
  }
  if (error.pattern.indexOf('@') >= 0) {
    if (!first) s += '、';
    s += `符號`;
    first = false;
  }
  return s;
}
